import React from 'react';
import {StyleSheet, View} from 'react-native';
import {ThemeProvider} from '@rneui/themed';
import type {Meta, StoryObj} from '@storybook/react-native-web-vite';

import rewardsTheme from '../../../theme/rewardsTheme';

import InStoreCode from './index';

const meta = {
  title: 'Components/Rewards/In-Store Code',
  component: InStoreCode,
  argTypes: {
    inStoreCode: {
      control: 'text',
    },
    color: {
      control: 'color',
    },
  },
  decorators: [
    Story => (
      <ThemeProvider theme={rewardsTheme}>
        <View style={styles.container}>
          <Story />
        </View>
      </ThemeProvider>
    ),
  ],
} satisfies Meta<typeof InStoreCode>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Default: Story = {
  args: {
    inStoreCode: 'BM 1245',
  },
};

export const ShortCode: Story = {
  args: {
    inStoreCode: 'AB123',
  },
};

export const LongCode: Story = {
  args: {
    inStoreCode: 'BOTTLEMART1234',
  },
};

export const NumericOnly: Story = {
  args: {
    inStoreCode: '123456',
  },
};

export const WithCustomColor: Story = {
  args: {
    inStoreCode: 'BM 1245',
    color: '#007AFF',
  },
};

export const AllVariants: Story = {
  render: () => (
    <View style={styles.variantsContainer}>
      <InStoreCode inStoreCode="BM 1245" />
      <InStoreCode inStoreCode="AB123" />
      <InStoreCode inStoreCode="123456" />
      <InStoreCode inStoreCode="SIPNSAVE99" />
      <InStoreCode inStoreCode="TC 7890" color="#FF6B35" />
    </View>
  ),
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 16,
  },
  variantsContainer: {
    gap: 24,
  },
});
